module.exports = __webpack_public_path__ + "img/lw.b3dcac71.png";